package com.mxpainting

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.letterSpacing
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px

@InitSilk
fun initSiteStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("body") {
        Modifier
            .fontFamily("Open Sans", "Helvetica Neue", "Helvetica", "Arial", "sans-serif")
            .styleModifier {
                property("background", "url('/img/roller.png') no-repeat center center fixed")
                property("background-size", "cover")
            }
    }

    ctx.stylesheet.registerStyleBase("h1, h2, h3, h4, h5, h6") {
        Modifier
            .fontFamily("Josefin Slab", "Helvetica Neue", "Helvetica", "Arial", "sans-serif")
            .fontWeight(700)
            .letterSpacing(1.px)
    }

    ctx.stylesheet.registerStyleBase("p") {
        Modifier
            .fontSize(1.25.em)
            .lineHeight(1.6)
            .color(Color("#000"))
    }
}
